export default __webpack_public_path__ + "static/media/HP_LOGO.508b3a8f.png";